import { useEffect, useState } from "react";

export default function AdminContactRequests({ token }) {
  const [contactRequests, setContactRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL; 
    const fetchContactRequests = async () => {
      try {
        const response = await fetch(`${API_URL}/admin/get_contact_requests.php`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Erreur ${response.status}`);
        }

        const data = await response.json();
        setContactRequests(data.contact_requests || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContactRequests();
  }, [token]);

  if (loading) return <p>Chargement des demandes...</p>;
  if (error) return <p className="error">Erreur : {error}</p>;
  if (contactRequests.length === 0) return <p>Aucune demande de contact pour le moment.</p>;

  return (
    <div className="admin-contact-requests">
      <h2>Demandes de contact</h2>
      <table className="contact-requests-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Status</th>

            <th>Nom</th>
            <th>Email</th>
            <th>Sujet</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {contactRequests.map((req) => {
            const createdAt = new Date(req.created_at);
            const now = new Date();
            const diffHours = (now - createdAt) / (1000 * 60 * 60); // différence en heures
            const isOlderThan48h = diffHours > 48;

            return (
              <tr key={req.id}>
                <td style={{ backgroundColor: isOlderThan48h ? 'orange' : 'transparent' }}>{req.id}</td>
                 <td style={{ backgroundColor: isOlderThan48h ? 'orange' : 'transparent' }}>
                  {createdAt.toLocaleString()}
                </td>               
                <td>{req.status}</td>
                <td>{req.nom}</td>
                <td>{req.email}</td>
                <td>{req.sujet}</td>
                <td>{req.message}</td>

              </tr>
            );
          })}
        </tbody>

      </table>

      <style jsx>{`
            .contact-requests-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 1rem;
            }
            .contact-requests-table th,
            .contact-requests-table td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
              color: #111;          /* couleur du texte plus visible */
            }
            .contact-requests-table th {
              background-color: #f4f4f4;
              color: #000;          /* texte de l'en-tête bien noir */
            }
            .error {
              color: red;
              font-weight: bold;    /* rend l'erreur plus visible */
            }
          `}</style>
    </div>
  );
}
